import loadable from '@loadable/component';

import './AboutPP.css';

export default loadable(() => {
  return import('./AboutPP.jsx');
});
